/**
 * Country type
 * DOC: https://schema.org/Country
 */

export default ({
  name
}) => ({
  '@type': 'Country',
  ...(name && {
    name
  })
});